export default __webpack_public_path__ + "static/media/vinyl.81e60351.png";